import React from "react";
import { ProfileView } from "./profile/ProfileView";
import { useProfile } from "./profile/useProfile";

const Profile: React.FC = () => <ProfileView state={useProfile()} />;

export default Profile;